<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadDepartments(1, null,true)">

      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('counselor_affiliation')" v-model="departmentFormData.name" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationDepartmentButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addDepartment">{{ $t('department_classification_added') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('counselor_affiliation')" v-model="departmentSearchParams.department" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('status')" v-model="departmentSearchParams.isActive" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadDepartments(1, null,true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="departmentDataContainer" :title="$tc('department', 2)" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-consultation-department-list
        :departments="departments"
        @customClickStatus="status"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-consultation-department-list>

      <template slot="footer">
        <paginate
          :total="departmentPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadDepartments"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import Department from '@/models/Department'
import SharedUserConfigurationConsultationDepartmentList from '@/views/Shared/Configuration/Consultation/Departments/List'
import Paginate from '@/mixins/paginate'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Configuration.Consultation.Departments',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationConsultationDepartmentList
  },
  data () {
    return {
      departmentsEdit: {},
      departments: {},
      departmentPages: 1,
      departmentFormData: {
        name: '',
        is_active: '',
        id: ''
      },
      departmentFormErrors: {},
      itemPerPage: null,
      departmentSearchParams: {
        department: typeof this.$route.query.department !== 'undefined' ? this.$route.query.department : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions
    }
  },
  mounted () {
    this.loadDepartments(this.initialPage, null, false, true)
  },
  methods: {
    async loadDepartments (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#departmentDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: {...this.groupSearchParams, page, itemPerPage}})
      }
      const response = await Department.all({ ...this.departmentSearchParams, page, itemPerPage })
      this.departments = response.data.data.departments
      this.departmentPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#departmentDataContainer > .con-vs-loading')
    },
    async addDepartment (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationDepartmentButton', scale: 0.45})
      if (this.departmentFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_department_error_message'),
          confirmButton: this.$t('confirm')
        })

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await Department.save(this.departmentFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadDepartments(1, this.itemPerPage)
        this.departmentFormData = {
          name: '',
          is_active: '',
          id: ''
        }
        this.departmentFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationDepartmentButton > .con-vs-loading')
    },
    async status (key) {
      try {
        if (this.departments[key].is_active === 1) {
          this.departments[key].is_active = 0
        } else {
          this.departments[key].is_active = 1
        }
        await Department.update(this.departments[key])
        this.departments[key].departmentFormErrors = {}
      } catch (e) {
        this.departments[key].departmentFormErrors = e.response.data.errors
      }
    },
    async edit (key) {
      this.departments[key].edit = true
      const editElem = this.departments[key]
      const editObj = {
        name: editElem.name
      }
      this.departmentsEdit[key] = editObj
    },
    async cancel (key) {
      this.departments[key].name = this.departmentsEdit[key].name
      this.departments[key].edit = false
      this.departments[key].departmentFormErrors = {}
      delete this.departmentsEdit[key]
    },
    async save (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('department_update_confirmation_title'),
          text: this.$t('department_update_confirmation_text'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationDepartmentButton${id}`, scale: 0.45})
          await Department.update(this.departments[key])
          this.departments[key].edit = false
          this.departments[key].departmentFormErrors = {}
          this.$vs.loading.close(`#updateConfigurationDepartmentButton${id} > .con-vs-loading`)
        }
      } catch (e) {
        this.departments[key].departmentFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateConfigurationDepartmentButton${id} > .con-vs-loading`)
      }
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Department.delete(id)
        this.loadDepartments(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationDepartmentButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
